module.exports = __webpack_public_path__ + "static/media/home-selected.3f4827a6.svg";